module.exports = __webpack_public_path__ + "static/img/home2.7b973b2b.png";